import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { SiteProvider, useSite } from "@/context/ThemeContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Chatbot } from "@/components/Chatbot";
import { LoadingScreen } from "@/components/LoadingScreen";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Courses from "@/pages/Courses";
import CourseCategory from "@/pages/CourseCategory";
import Admission from "@/pages/Admission";
import Contact from "@/pages/Contact";
import Events from "@/pages/Events";
import Achievements from "@/pages/Achievements";
import SpeakEase from "@/pages/SpeakEase";
import Gallery from "@/pages/Gallery";
import Activities from "@/pages/Activities";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function PublicLayout() {
  const { data } = useSite();
  const [show, setShow] = useState(true);
  useEffect(() => {
    if (data) { const t = setTimeout(() => setShow(false), 700); return () => clearTimeout(t); }
  }, [data]);
  return (
    <div className="min-h-screen bg-bg noise-overlay">
      <LoadingScreen show={show || !data} />
      <Navbar />
      <main><Outlet /></main>
      <Footer />
      <Chatbot />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <AuthProvider>
          <ScrollToTop />
          <Toaster position="top-center" />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/courses/:categoryId" element={<CourseCategory />} />
              <Route path="/events" element={<Events />} />
              <Route path="/achievements" element={<Achievements />} />
              <Route path="/speakease" element={<SpeakEase />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/activities" element={<Activities />} />
              <Route path="/admission" element={<Admission />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/admin" element={<AdminGate />} />
          </Routes>
        </AuthProvider>
      </SiteProvider>
    </BrowserRouter>
  );
}

function AdminGate() {
  const { user, ready } = useAuth();
  return (
    <div className="min-h-screen bg-bg">
      {!ready ? (
        <div className="min-h-screen flex items-center justify-center text-t">Loading…</div>
      ) : user ? (
        <AdminDashboard />
      ) : (
        <AdminLogin />
      )}
    </div>
  );
}

export default App;
